module.exports = {
  title: `Deep Dive Magic Code`,
  description: `오픈소스를 톺아보며 매직 코드라 생각했던 부분들의 동작 원리와 의미, 의도를 파악해보고 서로의 생각을 나누기 위한 블로그`,
  author: `Goidle`,
  introduction: `오픈소스를 톺아보며 매직 코드라 생각했던 부분들의 동작 원리와 의미, 의도를 파악해보고 서로의 생각을 나누기 위한 블로그`,
  siteUrl: `https://goidle.github.io/`, // Your blog site url
  icon: `assets/felog.png`, // Add your favicon
  keywords: [
    `react`,
    'redux',
    'javascript',
    'web',
    'development',
    'frontend',
    '리액트',
    '리덕스',
    '리액트18',
    '리액트 18',
    'react 18',
    'react18',
    'transition lane',
    'concurrent render',
  ],
  comment: {
    utterances: 'goidle/goidle.github.io', // Your repository for archive comment
  },
  configs: {
    countOfInitialPost: 10, // Config your initial count of post
  },
  ga: 'UA-154981109-1', // Add your google analytics tranking ID,
  email: 'kgc4958@gmail.com',
  url: 'https://goidle.github.io',
}
